import { combineReducers } from 'redux'
import { appReducer } from './modules/app'
import { loansReducer } from './modules/loans'

export const rootReducer = combineReducers({
  app: appReducer,
  loans: loansReducer,
})

export type RootState = ReturnType<typeof rootReducer>
